import React from "react";

import styles from './Navigation.module.css';

import {NavLink} from 'react-router-dom';
import { useSelector } from 'react-redux';

import * as routeConstants from '../../constants/routeConstants';

const IS_DEV = process.env.REACT_APP_IS_DEV === 'true';
const ENABLE_SKILL_SCHEDULER = process.env.REACT_APP_ENABLE_SKILL_SCHEDULER === 'true';
const HIDE_QUEUE_MEMBERSHIP = process.env.REACT_APP_QUEUE_MEMBERS_HIDE === 'true';
const HIDE_QUEUE_ACTIVATIONS = process.env.REACT_APP_QUEUE_ACTIVATIONS_HIDE === 'true';
const HIDE_SKILL_LEVELS = process.env.REACT_APP_SKILL_LEVELS_HIDE === 'true';
const HIDE_SKILL_GROUPS = process.env.REACT_APP_SKILL_GROUPS_HIDE === 'true';

const Navigation = () => {

    const {isLoggedIn, hasSkillGroupPermission} = useSelector(state => state.auth);

    const getNavLinkClass = (navData) => {
        return navData.isActive ? styles.active : "";
    }

    return (
        <nav className={styles.menu}>
            <ul>
                <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_DEFAULT}>Home</NavLink></li>
                {false && IS_DEV && isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_USERS}>Users</NavLink></li>}
                {false && IS_DEV && isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_SKILLS}>Skills</NavLink></li>}
                {false && IS_DEV && isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_QUEUES}>Queues</NavLink></li>}
                {!HIDE_SKILL_LEVELS && isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_SKILL_LEVELS}>Skill levels</NavLink></li>}
                {!HIDE_QUEUE_ACTIVATIONS && isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_QUEUE_ACTIVATION}>Queue activation</NavLink></li>}
                {!HIDE_QUEUE_MEMBERSHIP && isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_QUEUE_MEMBERS}>Queue members</NavLink></li>}
                {!HIDE_SKILL_GROUPS && isLoggedIn && hasSkillGroupPermission && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_SKILL_GROUPS}>Skill Groups</NavLink></li>}
                {ENABLE_SKILL_SCHEDULER && isLoggedIn && <li><NavLink className={getNavLinkClass} to={routeConstants.ROUTE_SKILL_SCHEDULER}>Skill Scheduler</NavLink></li>}
            </ul>
        </nav>
    )
}


export default Navigation;